import { requestHandler } from 'lib/api';

export const activateIntegration = async (
  dispatch: any,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/integrations/${id}/activate`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const getIntegrationStatusByInternalName = async (
  dispatch: any,
  internalName: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/integrations/status/internalName/${internalName}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getIntegrationsCatalog = async (dispatch: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/integrations/catalog`,
    dispatch,
  });
  if (response) return response.data;
};

export const getIntegrationStatus = async (dispatch: any, id: number) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/integrations/${id}/status`,
    dispatch,
  });
  if (response) return response.data;
};
